// ✅ Correct GetIcon component
import { useMemo } from '@wordpress/element';
import { flattenIconsArray } from '../../block/icon/utils';
import { defaultIcon } from '../../block/icon/icons/default';
import getIcons from '../../block/icon/icons';

export const GetIcon = ({ value = "" }) => {
	const iconsAll = useMemo(() => flattenIconsArray(getIcons()), []);
	const namedIcon = iconsAll.find((i) => i.name === value);
	const printedIcon = namedIcon?.icon || defaultIcon;

	return printedIcon;
};
